/**
 * EventsTable — composes the table header + EventRow body + "Aeltere laden"
 * button. Expand-state is a `Set<string>` lifted into props so parallel-expand
 * works across re-fetches and survives toolbar changes.
 */

import React from 'react';
import {
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import type { CreateIssueResponse, PortalEvent } from '../../services/types';
import EventRow from './EventRow';

interface Props {
  events: PortalEvent[];
  expandedIds: ReadonlySet<string>;
  onToggleRow: (id: string) => void;
  hasMore: boolean;
  loadingMore: boolean;
  onLoadMore: () => void;
  onIssueCreated?: (eventId: string, response: CreateIssueResponse) => void;
}

const EventsTable: React.FC<Props> = ({
  events,
  expandedIds,
  onToggleRow,
  hasMore,
  loadingMore,
  onLoadMore,
  onIssueCreated,
}) => {
  return (
    <Stack spacing={1.5}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Zeitpunkt</TableCell>
              <TableCell>Typ</TableCell>
              <TableCell>Kategorie</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Zusammenfassung</TableCell>
              <TableCell>Nutzer</TableCell>
              <TableCell>Issue</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event) => (
              <EventRow
                key={event.id}
                event={event}
                expanded={expandedIds.has(event.id)}
                onToggle={() => onToggleRow(event.id)}
                onIssueCreated={onIssueCreated}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {hasMore && (
        <Stack direction="row" justifyContent="center">
          <Button onClick={onLoadMore} disabled={loadingMore} variant="outlined">
            {loadingMore ? 'Lade …' : 'Aeltere laden'}
          </Button>
        </Stack>
      )}
    </Stack>
  );
};

export default EventsTable;
